export enum OperationType {
    Deposit = 'deposit',
    Withdraw = 'withdraw',
}

export interface Range<T> {
    min?: T;
    max?: T;
}

export interface PaymentsListRequest {
    page: number;
    count: number;
    userId?: string; // keeping as string input
    amountRange?: Range<number>; // kopecks
    dateRange?: Range<string>; // ISO strings
    wallet?: string;
    paymentMethodId?: number;
    statuses?: number[];
    // Applies only for withdrawals
    initializer?: Initializer;
    /** Только депозиты с бонусом по промокоду (для выводов не применяется) */
    onlyWithPromoCode?: boolean;
}

export interface PaymentRow {
    id: number;
    systemType: number;
    paymentMethodId: number;
    status: number;
    paymentMethodTitle: string;
    currency: string;
    userId: string;
    amount: number; // kopecks
    ourBenefit: number; // kopecks
    createdAt?: string;
    completedAt?: string;
    rawEvent: string;
    feeDetails: string;
    /** Промокод, по которому к депозиту начислен бонус; null — без промокода */
    promoCode?: string | null;
    /** Бонус по промокоду сверх суммы депозита, копейки */
    promoBonusAmount?: number;
}

export interface PaymentsListResult {
    total: number;
    items: PaymentRow[];
    page: number;
    count: number;
}


export enum Initializer {
    User = 0,
    Admin = 1,
}


